import * as yup from 'yup';
import { IBiddingFormSchemaTranslations } from './BiddingForm.types';
import { MIN_QUANTITY_REQUIRED_MT } from '@customer-platform-shared//components/Forms/Forms.const';

function maxNumbersAfterDecimalValidation(number?: number) {
  if (number === undefined) {
    return true;
  }
  return /^\d+(\.\d{0,5})?$/.test(number.toString());
}

export default function getBiddingFormSchema({
  required,
  requiredCheckbox,
  maxNumbersAfterDecimal,
  minQuantityRequired,
}: IBiddingFormSchemaTranslations) {
  return yup.object().shape({
    price: yup
      .number()
      .positive()
      .test(
        'maxNumbersAfterDecimal',
        maxNumbersAfterDecimal,
        maxNumbersAfterDecimalValidation,
      )
      .required(required)
      .transform((val, orig) => (orig === '' ? undefined : val)),
    quantity: yup
      .number()
      .required(required)
      .min(MIN_QUANTITY_REQUIRED_MT, minQuantityRequired)
      .test(
        'maxNumbersAfterDecimal',
        maxNumbersAfterDecimal,
        maxNumbersAfterDecimalValidation,
      )
      .transform((val, orig) => (orig === '' ? undefined : val)),

    termsAgreed: yup
      .boolean()
      .oneOf([true], requiredCheckbox)
      .required(requiredCheckbox),
  });
}
